import React, { useContext, useRef, useState } from "react";
import CenterIcon from "../components/ui/CenterIcon";
import { description, printRelativeDate, printUnit } from "../utils/ar";
import CommunityCreateCommentForm from "./CommunityCreateCommentForm";
import CommunityCommentCard from "./CommunityCommentCard";
import AuthContext from "../context/AuthContext";
import Button from "../components/ui/Button";
import auth from "../services/authServices";
import http from "../services/httpServices";
import LoadingIcon from "../components/ui/LoadingIcon";
import { baseURL } from "../config";
import { showPicture } from "../services/contentServices";
import { useLanguage } from "../context/LanguageContext";

const CommunityPostCard = ({ post, posts, setPosts, category, setCategory }) => {
    const { adminToken } = useContext(AuthContext);
    const { language } = useLanguage();
    const [isLoading, setIsLoading] = useState(false);
    const [isImageLoading, setIsImageLoading] = useState(true);

    const imageSrcRef = useRef();
    const content = {
        pendingReview: {
            en: "Pending Review",
            ar: "قيد المراجعة",
            de: "Wird überprüft",
        },
        closePost: {
            en: "Close Post",
            ar: "اغلاق الموضوع",
            de: "Beitrag schließen",
        },
        openPost: {
            en: "Open Post",
            ar: "فتح الموضوع",
            de: "Beitrag öffnen",
        },
        deletePost: {
            en: "Delete",
            ar: "حذف",
            de: "Löschen",
        },
        approvePost: {
            en: "Approve & Publish",
            ar: "قبول الموضوع و نشره",
            de: "Beitrag genehmigen und veröffentlichen",
        },
        comments: {
            en: "Comments",
            ar: "التعليقات",
            de: "Kommentare",
        },
        noComments: {
            en: "No comments yet.",
            ar: "لا توجد تعليقات بعد.",
            de: "Noch keine Kommentare.",
        },
        commentCount: {
            en: "comment",
            ar: "تعليق",
            de: "Kommentar",
        },
    };
    const handlePostAction = async (action = "approve") => {
        const token = auth.getAdminToken();
        const config = auth.getAuthConfig(token);
        setIsLoading(true);

        try {
            if (action === "delete") {
                const { data } = await http.delete(
                    `/api/community/community_categories/${category.id}/posts/${post.id}`,
                    config
                );
                let communinty_category_pending_posts = category.community_posts.filter(
                    (value) => value.id !== post.id
                );
                setCategory({
                    ...category,
                    community_posts: [...communinty_category_pending_posts],
                });

                let newPosts = posts.filter((value) => value.id !== post.id);

                setPosts([...newPosts]);
            } else if (action === "approve") {
                const { data } = await http.post(
                    `/api/community/community_categories/${category.id}/posts/${post.id}/approve`,
                    {},
                    config
                );
                let newPost = category.community_posts.filter((value) => value.id === post.id);
                newPost[0].is_approved = true;
                let communinty_category_pending_posts = category.community_posts.filter(
                    (value) => value.id !== post.id
                );
                setCategory({
                    ...category,
                    community_posts: [...communinty_category_pending_posts],
                });
                let newPosts = [...newPost, ...posts];
                setPosts(newPosts);
            } else if (action === "close") {
                const { data } = await http.post(
                    `/api/community/community_categories/${category.id}/posts/${post.id}/close`,
                    {},
                    config
                );
                let newPosts = posts.map((value) => {
                    if (value.id === post.id) {
                        let newValue = {
                            ...value,
                            is_closed: 1,
                        };
                        return newValue;
                    } else {
                        return value;
                    }
                });
                setPosts(newPosts);
            } else if (action === "open") {
                const { data } = await http.post(
                    `/api/community/community_categories/${category.id}/posts/${post.id}/open`,
                    {},
                    config
                );

                let newPosts = posts.map((value) => {
                    if (value.id === post.id) {
                        let newValue = {
                            ...value,
                            is_closed: 0,
                        };
                        return newValue;
                    } else {
                        return value;
                    }
                });
                setPosts(newPosts);
            } else if (action === "pin_post") {
                const { data } = await http.post(
                    `/api/community/community_categories/${category.id}/posts/${post.id}/pin`,
                    {},
                    config
                );

                let newPosts = posts.map((value) => {
                    if (value.id === post.id) {
                        let newValue = {
                            ...value,
                            is_pinned: 1,
                        };
                        return newValue;
                    } else {
                        return value;
                    }
                });
                setPosts(newPosts);
            } else if (action === "unpin_post") {
                const { data } = await http.post(
                    `/api/community/community_categories/${category.id}/posts/${post.id}/unpin`,
                    {},
                    config
                );

                let newPosts = posts.map((value) => {
                    if (value.id === post.id) {
                        let newValue = {
                            ...value,
                            is_pinned: 0,
                        };
                        return newValue;
                    } else {
                        return value;
                    }
                });
                setPosts(newPosts);
            }

            setIsLoading(false);
        } catch (error) {
            setIsLoading(false);
        }
    };
    return (
        <div className="bg-primary-container clr-text-primary smooth rounded-2xl">
            <div className="flex justify-between items-center w-full">
                <div className="flex-center-both p-2 space-x-2 space-x-reverse">
                    <div className="sm:w-10 w-7 sm:h-10 h-7 rounded-full bg-yellow-100 dark:bg-yellow-700 flex-center-both smooth">
                        <CenterIcon
                            className="w-full h-full text-yellow-800 dark:text-yellow-400 smooth "
                            iconProperties={{ className: "h-3/4 w-3/4" }}
                            icon="iconamoon:profile-fill"
                        />
                    </div>
                    {/* <div className="">{post.user.full_name}</div> */}
                    <div className="space-y-1">
                        <div className="font-w-bold">{post.user.full_name}</div>
                        <div className="clr-text-secondary smooth font-smaller flex space-x-1 space-x-reverse">
                            <CenterIcon icon="icon-park-twotone:time" className="pt-0.5" />
                            <span>
                                {printRelativeDate(post.created_at)}
                                {post.is_approved ? (
                                    ""
                                ) : (
                                    <>
                                        {" - "}
                                        <span className="text-yellow-500 opacity-70 underline">
                                            {content.pendingReview[language]}
                                        </span>
                                    </>
                                )}
                            </span>
                        </div>
                    </div>
                </div>
                {adminToken ? (
                    <>
                        <div className="px-5">
                            <div className="h-0.5 bg-cyan-700 w-full rounded-md smooth"></div>
                        </div>
                        <div className="flex-center-both space-x-2 space-x-reverse mx-3 py-2">
                            {/* {post.is_pinned ? (
                                <>
                                    <div className="flex-center-both flex-row font-smaller space-x-2 space-x-reverse">
                                        <div className="rounded-full bg-yellow-500 py-2 px-2 font-h3">
                                            <CenterIcon icon={"solar:pin-outline"} />
                                        </div>
                                    </div>
                                    <Button
                                        color="midNight"
                                        className="py-1 px-2"
                                        onClick={() => handlePostAction("unpin_post")}
                                        isLoading={isLoading}
                                    >
                                        الغاء تثبيت الموضوع
                                    </Button>
                                </>
                            ) : (
                                <>
                                    <Button
                                        color="midNight"
                                        className="py-1 px-2"
                                        onClick={() => handlePostAction("pin_post")}
                                        isLoading={isLoading}
                                    >
                                        تثبيت الموضوع
                                    </Button>
                                </>
                            )} */}
                            {post.is_closed ? (
                                <Button
                                    color="yellow"
                                    className="py-1 px-2"
                                    onClick={() => handlePostAction("open")}
                                    isLoading={isLoading}
                                >
                                    {content.openPost[language]}
                                </Button>
                            ) : (
                                <Button
                                    color="slate"
                                    className="py-1 px-2"
                                    onClick={() => handlePostAction("close")}
                                    isLoading={isLoading}
                                >
                                    {content.closePost[language]}
                                </Button>
                            )}
                            {post.is_approved ? (
                                <Button
                                    color="rose"
                                    onClick={() => handlePostAction("delete")}
                                    isLoading={isLoading}
                                >
                                    {content.deletePost[language]}
                                </Button>
                            ) : null}
                        </div>
                    </>
                ) : (
                    ""
                )}
            </div>
            <div className="px-5">
                <div className="h-0.5 bg-secondary-container w-full rounded-md smooth"></div>
            </div>

            <div className="py-5 sm:px-2 px-5">{description(post.description, true)}</div>
            {post.image_source ? (
                <div className="py-5">
                    <div className="w-full rounded-md relative overflow-hidden text-center h-[400px]">
                        <img
                            src={`${baseURL}/${post.image_source}`}
                            alt="course"
                            ref={imageSrcRef}
                            onLoad={() => {
                                setIsImageLoading(false);
                            }}
                            className={` ${
                                isImageLoading ? "hidden " : ""
                            } h-full max-w-full mx-auto cursor-pointer`}
                            onClick={() => showPicture(imageSrcRef.current.src, false)}
                        />
                        {isImageLoading ? (
                            <div className="h-full bg-slate-300 dark:bg-slate-50/10 flex-center-both font-h1 font-w-bold">
                                <div className="flex flex-row space-x-3 space-x-reverse">
                                    <LoadingIcon className={"font-big text-blue-500"} />
                                </div>
                            </div>
                        ) : null}
                    </div>
                </div>
            ) : (
                ""
            )}

            {post.is_approved ? (
                <>
                    <div className="px-5">
                        <div className="flex items-center justify-end">
                            <div className="font-smaller clr-text-secondary smooth py-2">
                                {printUnit(post.community_comments.length, "تعليق", language)}
                            </div>
                        </div>
                    </div>
                    <div className="px-5">
                        <div className="h-0.5 bg-secondary-container w-full rounded-md smooth"></div>
                    </div>
                    <div className="py-2 flex-center-both clr-text-secondary smooth">
                        {" "}
                        {content.comments[language]}
                    </div>
                    <div className="px-5">
                        <div className="h-0.5 bg-secondary-container w-full rounded-md smooth"></div>
                    </div>
                    <div className="space-y-5">
                        {post.is_closed ? (
                            ""
                        ) : (
                            <CommunityCreateCommentForm
                                posts={posts}
                                setPosts={setPosts}
                                category={category}
                                post={post}
                            />
                        )}
                        <div className="p-2">
                            <div className="sm:px-7 px-6 bg-third-container rounded-md py-4 space-y-2">
                                {post.community_comments.map((comment) => {
                                    return (
                                        <CommunityCommentCard
                                            posts={posts}
                                            setPosts={setPosts}
                                            category={category}
                                            post={post}
                                            key={comment.id}
                                            comment={comment}
                                        />
                                    );
                                })}
                            </div>
                        </div>
                    </div>
                </>
            ) : adminToken ? (
                <>
                    <div className="px-5">
                        <div className="h-0.5 bg-secondary-container w-full rounded-md smooth"></div>
                    </div>
                    <div className="flex-center-both space-x-2 space-x-reverse py-2">
                        <Button
                            color="royalBlue"
                            onClick={() => handlePostAction("approve")}
                            isLoading={isLoading}
                        >
                            {content.approvePost[language]}
                        </Button>
                        <Button
                            color="rose"
                            onClick={() => handlePostAction("delete")}
                            isLoading={isLoading}
                        >
                            {content.deletePost[language]}
                        </Button>
                    </div>
                    <div className="px-5">
                        <div className="h-0.5 bg-secondary-container w-full rounded-md smooth"></div>
                    </div>
                    <div className="space-y-5">
                        <CommunityCreateCommentForm
                            posts={category.community_posts}
                            setPosts={(posts) => {
                                // let newCommunityPosts =
                                setCategory({
                                    ...category,
                                    community_posts: posts,
                                });
                            }}
                            category={category}
                            post={post}
                        />
                        <div className="p-2">
                            <div className="sm:px-7 px-6 bg-third-container rounded-md py-4 space-y-2">
                                {post.community_comments.map((comment) => {
                                    return (
                                        <CommunityCommentCard
                                            posts={posts}
                                            setPosts={setPosts}
                                            category={category}
                                            post={post}
                                            key={comment.id}
                                            comment={comment}
                                        />
                                    );
                                })}
                            </div>
                        </div>
                    </div>
                </>
            ) : (
                ""
            )}
        </div>
    );
};

export default CommunityPostCard;
